<template>
  <a-modal
      :visible="visible"
      :footer="null"
      @cancel="closeModal"
      class="main-modal"
      :class="{'main-modal__horiz_view': !notGallery}">
    <MonumentListContent v-if="pageRoute === 'monuments'"/>
    <CemeteryListContent v-else/>
  </a-modal>
</template>

<script>
import MonumentListContent from '@/components/common/main-page-mobile-modal/components/monument-list-content';
import CemeteryListContent from '@/components/common/main-page-mobile-modal/components/cemetery-list-content';
import { mapGetters, mapActions } from 'vuex';

export default {
name: "MainModal",
  components: {
    [MonumentListContent.name]: MonumentListContent,
    [CemeteryListContent.name]: CemeteryListContent,
  },
  props: {
    pageRoute: {
      type: String
    }
  },
  computed: {
  ...mapGetters({
    visible: 'modal/getMainModalVisible',
    notGallery: 'cemeteries/getGallery'
  }),
  },
  methods: {
  ...mapActions({
    close: 'modal/mainModalVisible'
  }),
    closeModal(){
      this.$emit('removeEvent')
      this.close(false);
    }
  },
}
</script>
<style lang="scss">
.main-modal {
  top: 20px;
  & .ant-modal-body {
    padding: 0px;
  }
  & .ant-list .ant-list-item-extra-wrap {
    padding: 4px 4px;
  }
  & .ant-list-split .ant-list-item {
    border: none;
  }
  & .ant-spin-container {
    :nth-child(even) {
      .ant-list-item-extra-wrap {
        background-color: #eeeeee;
      }
    }
  }
  .ant-list-pagination {
    padding: 5px 10px 20px;
  }
  &__horiz_view{
    & .ant-list.ant-list-vertical .ant-list-item-extra{
      height: 260px !important;
    }
  }
}
</style>
